import {
    createContext,
    useContext,
    useState,
    useEffect,
    useRef,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NavBlockContext = createContext();

export const NavBlockProvider = ({ children }) => {
    const [hasSelectedEmail, setHasSelectedEmail] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const [isInformationModalOpen, setIsInformationModalOpen] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(null);
    const [openUnsavedModal, setOpenUnsavedModal] = useState(null);
   const shouldBlockNavigation = hasSelectedEmail || hasUnsavedChanges;

    // Prevent reopening the modal when we intentionally go back
    const ignoreNextPopState = useRef(false);

    const isGuardedPage = location.pathname.startsWith("/verzoeken/overzicht/") ||
        location.pathname.startsWith("/home");

    // Browser Back button
    useEffect(() => {

        if (!isGuardedPage) return;
        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            // Allow one real back navigation
            if (ignoreNextPopState.current) {
                ignoreNextPopState.current = false;
                return;
            }

            if (!shouldBlockNavigation) {
                ignoreNextPopState.current = true;
                window.history.back();
                return;
            }

            // Stay on current page
            window.history.pushState(null, "", window.location.href);

            // Save the navigation
            setPendingNavigation(() => () => {
                ignoreNextPopState.current = true;
                window.history.back();
                navigate(-1);
            });

            if (openUnsavedModal) {
                openUnsavedModal();
            } else {
                setIsInformationModalOpen(true);
            }
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isGuardedPage,
    hasSelectedEmail,
    hasUnsavedChanges,
    openUnsavedModal,
    navigate,]);

    // Navigation from sidebar/buttons
    const guardedNavigate = (to, options = {}) => {
      
        if (isGuardedPage && shouldBlockNavigation) {
         
            setPendingNavigation(() => () => navigate(to, options));
            if (openUnsavedModal) {
                openUnsavedModal();
            } else {
                setIsInformationModalOpen(true);
            }
            return;
        }

        navigate(to, options);
    };

    const proceedNavigation = () => {
        const navigation = pendingNavigation;

        setHasSelectedEmail(false);
        setHasUnsavedChanges(false);

        setPendingNavigation(null);
        if (openUnsavedModal) {
            openUnsavedModal();
        } else {
            setIsInformationModalOpen(true);
        }

        if (navigation) {
            navigation();
        }
    };
    const cancelNavigation = () => {
        setPendingNavigation(null);
        if (openUnsavedModal) {
            openUnsavedModal();
        } else {
            setIsInformationModalOpen(true);
        }
    };

    return (
        <NavBlockContext.Provider
            value={{
                guardedNavigate,
                setHasSelectedEmail,
                isInformationModalOpen,
                setIsInformationModalOpen,
                pendingNavigation,
                proceedNavigation,
                cancelNavigation,
                hasUnsavedChanges,
                setHasUnsavedChanges,
                setOpenUnsavedModal,
                openUnsavedModal,

            }}
        >
            {children}
        </NavBlockContext.Provider>
    );
};

export const useNavBlock = () => useContext(NavBlockContext);